import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Organization } from '../_models/organization';

import { environment } from '../../environments/environment';

@Injectable()
export class OrganizationService {
  constructor(private http: Http) { }

  getAll(): Promise<Organization[]> {
    return this.http.get(environment.apiUrl + 'organizations')
      .toPromise()
      .then((response: Response) => response.json())
      .catch(x => console.log(x));
  }

  getOrg(id: number): Promise<Organization> {
    return this.http.get(environment.apiUrl + 'organizations/' + id)
      .toPromise()
      .then((response: Response) => { return response.json(); });
  }

  createOrg(model) {
    let url = environment.apiUrl + 'organizations';
    let body = JSON.stringify(model);

    return this.http.post(url, body)
      .toPromise()
      .then((response: Response) => {
        if (response.status === 201) {
          return response.json();
        } else {
          throw response.json().error;
        }
      });
  }

  editOrg(model: Organization) {
    let url = environment.apiUrl + 'organizations/' + model.id;
    let body = JSON.stringify(model);

    return this.http.post(url, body)
      .toPromise()
      .then((response: Response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw response.json().error;
          }
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/_services/organization.service.ts